import 'shared/common'
import '@carwow/carwow_theme/app/javascript/components/segmentation_nav'
import '@carwow/carwow_theme/app/javascript/components/media_slider'

document.addEventListener('DOMContentLoaded', () => {
  if (window.Carwow && window.Carwow.registerBugsnagVolumeError) {
    window.Carwow.registerBugsnagVolumeError((error) => {
      const frameMissingErrorMessage = /the response \([0-9]+\) did not contain the expected <turbo-frame/gmi
      const isFrameMissingError = frameMissingErrorMessage.test(error.errorMessage)
      return isFrameMissingError
    })
  }
})
